import axios from "axios";

import envs from "config/envs";

import { refreshAccessToken } from "services/Auth.service";

let isRefreshing = false;
let refreshQueue = [];

export const api = axios.create({
  baseURL: envs.NEW_SERVICE_URL,
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error?.config;

    if (error?.response?.status !== 401) {
      return Promise.reject(error);
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        refreshQueue.push({ resolve, reject });
      })
        .then(() => api(originalRequest))
        .catch((err) => Promise.reject(err));
    }

    isRefreshing = true;

    try {
      await refreshAccessToken();

      refreshQueue.forEach((p) => p.resolve());
      refreshQueue = [];

      return api(originalRequest);
    } catch (err) {
      sessionStorage.setItem("@csh-brasil-refresh", "true");
      window.dispatchEvent(new Event("session-expired"));

      refreshQueue.forEach((p) => p.reject(err));
      refreshQueue = [];

      return Promise.reject(err);
    } finally {
      isRefreshing = false;
    }
  }
);
